import { Thead, Tr, Th } from "@lightspeed/cirrus-table";
import styled from "@emotion/styled";
import { useSelector } from "react-redux";
import { uiSelector } from "../../../redux/slices/uiSlice";
import TableHeaderItem from "./TableHeaderItem";

const SECTION_HEADER_HEIGHT = 48;

const SectionTh = styled(Th)`
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 102;
  padding: 10px 12px;
  border-bottom: 1px solid rgba(28, 41, 61, 0.08);
  border-right: ${({ dividerAfter, dividerColor }) =>
    dividerAfter ? `3px solid ${dividerColor || "#88aef5"}` : "none"};
`;

const SectionInner = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SectionPill = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 16px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  background: ${({ color }) => color || "#346fcf"};
  color: #fff;
`;

const HeaderRow = styled(Tr)`
  th {
    top: ${({ hasSectionHeaders }) =>
      hasSectionHeaders ? `${SECTION_HEADER_HEIGHT}px` : "0"};
  }
`;

const TableHeader = ({
  data,
  sectionHeaders = [],
  sortState,
  changeSortState,
}) => {
  const { theme } = useSelector(uiSelector);
  const hasSectionHeaders = sectionHeaders.length > 0;

  return (
    <Thead>
      {hasSectionHeaders && (
        <Tr className={theme === "flame" ? "" : "dark-table"}>
          {sectionHeaders.map((section) => (
            <SectionTh
              key={section.id}
              colSpan={section.span}
              dividerAfter={section.dividerAfter}
              dividerColor={section.dividerColor}
              style={{
                background: section.background,
              }}
            >
              <SectionInner>
                <SectionPill color={section.color}>{section.label}</SectionPill>
              </SectionInner>
            </SectionTh>
          ))}
        </Tr>
      )}
      <HeaderRow
        hasSectionHeaders={hasSectionHeaders}
        className={`${theme === "flame" ? "" : "dark-table"}`}
      >
        {data.map((item, index) => (
          <TableHeaderItem
            sortState={sortState}
            changeSortState={changeSortState}
            index={index}
            item={item}
            hasSectionHeaders={hasSectionHeaders}
            key={item.id}
          />
        ))}
      </HeaderRow>
    </Thead>
  );
};

export default TableHeader;
